package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.ArrowForwardW500Rounded: ImageVector
    get() {
        if (_arrowForwardW500Rounded != null) {
            return _arrowForwardW500Rounded!!
        }
        _arrowForwardW500Rounded = Builder(name = "ArrowForwardW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(633.85f, 525.5f)
                lineTo(197.37f, 525.5f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadToRelative(13.18f, -13.17f, 32.33f, -13.17f)
                horizontalLineToRelative(436.48f)
                lineTo(447.17f, 247.83f)
                quadToRelative(-13.67f, -13.68f, -13.29f, -32.07f)
                quadToRelative(0.38f, -18.39f, 14.05f, -32.06f)
                quadToRelative(13.68f, -12.68f, 32.07f, -13.06f)
                quadToRelative(18.39f, -0.38f, 32.07f, 13.29f)
                lineToRelative(264.0f, 264.0f)
                quadToRelative(6.71f, 6.72f, 9.81f, 14.92f)
                quadToRelative(3.1f, 8.19f, 3.1f, 17.15f)
                quadToRelative(0.0f, 8.96f, -3.1f, 17.15f)
                quadToRelative(-3.1f, 8.2f, -9.81f, 14.92f)
                lineTo(511.83f, 776.3f)
                quadToRelative(-12.92f, 12.92f, -31.57f, 12.92f)
                reflectiveQuadToRelative(-32.33f, -12.92f)
                quadToRelative(-13.67f, -13.67f, -13.67f, -32.44f)
                quadToRelative(0.0f, -18.77f, 13.67f, -32.45f)
                lineTo(633.85f, 525.5f)
                close()
            }
        }
        .build()
        return _arrowForwardW500Rounded!!
    }

private var _arrowForwardW500Rounded: ImageVector? = null
